import { FDealType, type FOfferType, isResidential } from '@/packages/JsonQuery';

interface IDealTypeOption {
  label: string;
  value: FDealType;
}

const COMMON_OPTIONS: IDealTypeOption[] = [
  { label: 'Купить', value: FDealType.Sale },
  { label: 'Снять', value: FDealType.RentLongterm },
];

const RESIDENTIAL_DEAL_TYPES: IDealTypeOption[] = [
  ...COMMON_OPTIONS,
  { label: 'Посуточно', value: FDealType.RentDaily },
];

export function getOptionsByOfferType(offerType: FOfferType): IDealTypeOption[] {
  switch (true) {
    case isResidential(offerType):
      return RESIDENTIAL_DEAL_TYPES;

    default:
      return COMMON_OPTIONS;
  }
}
